<template>
  <div class="banner">
    <swiper :options="swiperOptiona" ref="mySwipers" class="swiper">
      <swiper-slide class="item" v-for="(item, index) in banner" :key="index">
        <div v-if="item.video == ''">
          <img :src="`http://www.icoolglobal.cn/${item.picurl}`" alt="" />
        </div>

        <div class="videos" v-if="item.video != ''">
          <video id="videoPlay01" style="z-index: 3000">
            <source type="video/mp4;" src data-src />
            你的浏览器不支持 <code data-v-2065c5bc>video</code> 标签.
          </video>
        </div>
      </swiper-slide>
    </swiper>
    <!-- <div class="swiper-pagination" slot="pagination"></div> -->
    <div class="btn">
      <div class="prev">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="next">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  data() {
    let _this = this;
    return {
      video: "",
      swiperOptiona: {
        pagination: {
          el: ".banner .swiper-pagination",
          clickable: true,
        },
        slidesPerView: 1,
        init: false,
        effect: "fade",
        // loop:true,
        autoplay: {
          disableOnInteraction: false,
          // stopOnLastSlide: true,
          delay: 5000,
        },

        navigation: {
          prevEl: ".banner .btn .prev",
          nextEl: ".banner .btn .next",
        },
        on: {
          slideChangeTransitionStart() {
            if(_this.video){
              _this.playStop(this.activeIndex);
            }
            
          },
        },
      },
    };
  },
  props: ["banner"],
  components: {
    swiper,
    swiperSlide,
  },
  mounted() {
    setTimeout(() => {
      this.$refs.mySwipers.swiper.init();
      if (this.video) {
        this.playVideo();
      }
    }, 1000);
  },
  watch: {
    banner(val) {
      val.forEach((item) => {
        if (item.video != ""&&item.video) {
          this.video = item.video;
        }else{
          item.video=''
        }
      });
    },
  },
  methods: {
    playVideo() {
      const audioPlayer = window.document.getElementById("videoPlay01");
      audioPlayer.src = this.video;
      audioPlayer.load();
      audioPlayer.play();
    },
    playStop(id) {
      const audioPlayer = window.document.getElementById("videoPlay01");
      if (id == 3) {
        audioPlayer.play();
      } else {
        audioPlayer.pause();
      }
    },
    gotoAbout() {
      window.open("/about.html", "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  position: relative;
  .swiper {
    height: 100vh;
    .item {
      position: relative;
      overflow: hidden;
      img {
        width: 100%;
        height: 100vh;
        object-fit: cover;
        display: block;
        z-index: 1;
        cursor: pointer;
        transform: scale(1);
        transition: all 5s;
      }
      .text {
        position: absolute;
        left: 10%;
        width: 80%;
        top: 45%;
        p {
          color: white;
          opacity: 0;
          transform: translateY(200px);
          transition: all 600ms ease-out;
        }
        p:nth-child(1) {
          font-family: "SOURCEHANSANSCN-LIGHT";
          font-size: 45px;
        }
        p:nth-child(2) {
          font-size: 37px;
          font-family: "it";
          text-transform: uppercase;
          margin: 30px 0;
          transition-delay: 200ms;
        }
        p:nth-child(3) {
          font-family: "it";
          font-size: 20px;
          margin-top: 20px;
          transition-delay: 600ms;
        }
      }
      .videos {
        height: 100vh;
        video {
          width: 100%;
          height: 100%;
          object-fit: fill;
        }
      }
    }
    .swiper-slide-active {
      img {
        transform: scale(1.05);
      }
      .text {
        p {
          opacity: 1;
          transform: translateX(0);
        }
      }
    }
  }
  .btn {
    position: absolute;
    bottom: 3%;
    right: 3%;
    display: flex;
    z-index: 100;
    width: 80px;
    justify-content: space-between;
    .prev {
      width: 30px;
      height: 30px;
      border: 1px solid #ffffff;
      border-radius: 50%;
      position: relative;
      cursor: pointer;
      outline: none;
      i {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 10px;
        color: #ffffff;
      }
    }
    .next {
      width: 30px;
      height: 30px;
      border: 1px solid #ffffff;
      border-radius: 50%;
      position: relative;
      cursor: pointer;
      outline: none;
      i {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 10px;
        color: #ffffff;
      }
    }
  }
  @media screen and (max-width: 1440px) {
    .swiper {
    }
  }
  @media screen and (max-width: 1000px) {
    .swiper {
      padding-top: 60px;
      height: auto;
      .item {
        // height: 210px;
        img {
          height: calc(100vh - 60px);
          object-fit: cover;
        }
        .text {
          top: 30%;
          p:nth-child(1) {
            font-size: 22px;
          }
          p:nth-child(2) {
            font-size: 18px;
          }
        }
        .videos {
          height: auto;
        }
      }
    }
    .btn {
      top: 90%;
    }
  }
}
</style>
<style scoped>
.banner .swiper-pagination {
  display: none;
  bottom: 50%;
  transform: translateY(50%);
  left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 1000;
}
.banner .swiper-pagination >>> .swiper-pagination-bullet {
  position: relative;
  width: 4px;
  height: 4px;
  border: 1px solid white;
  border-radius: 50%;
  margin: 15px 15px;
  background-color: white;
  opacity: 1;
}
.banner .swiper-pagination >>> .swiper-pagination-bullet::before {
  content: "";
  display: inline-block;
  position: absolute;
  left: -9px;
  top: -9px;
  width: 20px;
  height: 20px;
  border: 1px solid white;
  border-radius: 50%;
  transition: all 600ms;
  opacity: 0;
}
.banner .swiper-pagination >>> .swiper-pagination-bullet-active::before {
  opacity: 1;
}
.banner .swiper-pagination >>> .swiper-pagination-bullet:focus {
  outline: none;
}
@media screen and (max-width: 1440px) {
  .banner .swiper-pagination {
    bottom: 20%;
  }
}
</style>
